import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("cc_install_dismissed") === "1");

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!deferred || dismissed) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem("cc_install_dismissed", "1");
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-96 z-[60] jr-card border border-violet-500/40 flex items-center gap-3 shadow-2xl shadow-violet-500/20" data-testid="install-prompt">
      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-500 to-cyan-400 grid place-items-center shrink-0">
        <Download className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-white">Install Curcompass</div>
        <div className="text-xs text-zinc-400">Add to your home screen for one-tap access.</div>
      </div>
      <button onClick={install} className="jr-btn-primary text-xs py-2 px-3 shrink-0" data-testid="install-app-btn">Install</button>
      <button onClick={dismiss} className="text-zinc-500 hover:text-white shrink-0" aria-label="dismiss" data-testid="install-dismiss-btn">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
